<template>
  <div v-if="!loading">
    <form>
      <v-row>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-if="form.type == 'CR'"
            v-model="form.score"
            label="Celkové hodnotenie - počet bodov (min. 0 max. 111):"
            readonly
          />
          <v-text-field
            v-if="form.type == 'RU'"
            v-model="form.score"
            label="Celkové hodnotenie - počet bodov (min. 0 max. 115):"
            readonly
          />
        </v-col>

        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-model="form.percentage"
            label="Celkové hodnotenie - % vyjadrenie (min. 0 max. 100 %):"
            readonly
          />
        </v-col>

        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-model="form.string_score"
            label="Riziko recidívy trestnej činnosti/resocializačná prognóza:"
            readonly
          />
        </v-col>
      </v-row>

      <v-layout
        wrap
        pt-5
      >
        <v-flex xs12>
          <v-subheader class="pl-0">
            Skóre
          </v-subheader>
          <v-slider
            v-if="form.type == 'RU'"
            v-model="form.score"
            min="-1"
            max="115"
            :color="color"
            thumb-label="always"
            :thumb-color="color"
            readonly
          />
          <v-slider
            v-if="form.type == 'CR'"
            v-model="form.score"
            min="-1"
            max="111"
            :color="color"
            thumb-label="always"
            :thumb-color="color"
            readonly
          />
        </v-flex>
      </v-layout>
      <v-subheader>Hodnotitelia</v-subheader>
      <v-divider />
      <v-row>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-model="form.assigned_to_socialny_pracovnik_full.string_details"
            label="Sociálny Pracovník"
            readonly
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-model="form.assigned_to_pedagog_full.string_details"
            label="Pedagóg"
            readonly
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-model="form.assigned_to_psycholog_full.string_details"
            label="Psychológ"
            readonly
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-model="form.assigned_to_pbs_full.string_details"
            label="Prílušník PBS"
            readonly
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-text-field
            v-if="form.type == 'RU'"
            v-model="form.assigned_to_socialny_kurator_full.string_details"
            label="Sociálny Kurátor"
            readonly
          />
        </v-col>
      </v-row>

      <v-subheader>Poznámky</v-subheader>
      <v-divider />
      <v-row v-if="form.poznamky_vsetky.rizikove_faktory">
        <v-col>
          <v-textarea
            v-model="form.poznamky_vsetky.rizikove_faktory"
            readonly
            label="Sociálny Pracovník"
            auto-grow
            rows="1"
          />
        </v-col>
      </v-row>

      <v-row v-if="form.poznamky_vsetky.penitenciarne_zaobchadzanie">
        <v-col>
          <v-textarea
            v-model="form.poznamky_vsetky.penitenciarne_zaobchadzanie"
            readonly
            label="Pedagóg"
            auto-grow
            rows="1"
          />
        </v-col>
      </v-row>

      <v-row v-if="form.poznamky_vsetky.psychologicke_vysetrenie">
        <v-col>
          <v-textarea
            v-model="form.poznamky_vsetky.psychologicke_vysetrenie"
            readonly
            label="Psychológ"
            auto-grow
            rows="1"
          />
        </v-col>
      </v-row>

      <v-row v-if="form.poznamky_vsetky.poznatky_pbs">
        <v-col>
          <v-textarea
            v-model="form.poznamky_vsetky.poznatky_pbs"
            readonly
            label="Príslušník PBS"
            auto-grow
            rows="1"
          />
        </v-col>
      </v-row>

      <v-row v-if="form.poznamky_vsetky.socialny_kurator">
        <v-col>
          <v-textarea
            v-model="form.poznamky_vsetky.socialny_kurator"
            readonly
            label="Sociálny Kurátor"
            auto-grow
            rows="1"
          />
        </v-col>
      </v-row>
    </form>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="complex" />
  </div>
</template>

<script>
import { APIService } from "@/http/APIService.js";
import FormSkeleton from "../../components/FormSkeleton.vue";

const apiService = new APIService();

export default {
  components: {
    "form-skeleton-component": FormSkeleton,
  },

  data: () => ({
    loading: false,
    form: {
      score: -1,
      assigned_to_socialny_pracovnik_full: {
        string_details: "",
      },
      assigned_to_pedagog_full: {
        string_details: "",
      },
      assigned_to_psycholog_full: {
        string_details: "",
      },
      assigned_to_pbs_full: {
        string_details: "",
      },
      assigned_to_socialny_kurator_full: {
        string_details: "",
      },
    },
  }),

  computed: {
    color() {
      if (this.form.type == "RU") {
        if (this.form.score == -1) return "grey";
        else if (this.form.score <= 25) return "green";
        else if (this.form.score <= 49) return "orange";
        else return "red";
      } else {
        if (this.form.score == -1) return "grey";
        else if (this.form.score <= 24) return "green";
        else if (this.form.score <= 48) return "orange";
        else return "red";
      }
    },
  },

  created() {
    this.getZaver();
  },

  methods: {
    getZaver() {
      this.loading = true;
      apiService.getCraForm(this.$route.params.id).then((response) => {
        this.form = response;
        this.loading = false;
      });
    },
  },
};
</script>